import React from "react";
import { bandColor } from "@/lib/risk";

// Semicircular SVG gauge for a 0-100 score.
export const RiskGauge = ({ score = 0, band = "Low", size = 240 }) => {
  const color = bandColor(band);
  const r = 90;
  const cx = 120;
  const cy = 120;
  const startAngle = 180;
  const sweep = (score / 100) * 180;

  const polar = (angle) => {
    const rad = (Math.PI * angle) / 180;
    return { x: cx + r * Math.cos(rad), y: cy - r * Math.sin(rad) };
  };

  const arcPath = (from, to) => {
    const p1 = polar(from);
    const p2 = polar(to);
    const large = Math.abs(to - from) > 180 ? 1 : 0;
    // angles measured CCW from positive x-axis; we draw from 180 down to 0
    return `M ${p1.x} ${p1.y} A ${r} ${r} 0 ${large} 1 ${p2.x} ${p2.y}`;
  };

  const valueAngle = startAngle - sweep;

  return (
    <div className="relative" style={{ width: size, height: size * 0.62 }} data-testid="risk-result-gauge">
      <svg viewBox="0 0 240 140" width={size} height={size * 0.62}>
        {/* track segments */}
        <path d={arcPath(180, 120)} stroke="hsl(var(--risk-low))" strokeOpacity="0.18" strokeWidth="14" fill="none" strokeLinecap="round" />
        <path d={arcPath(120, 60)} stroke="hsl(var(--risk-medium))" strokeOpacity="0.18" strokeWidth="14" fill="none" />
        <path d={arcPath(60, 0)} stroke="hsl(var(--risk-high))" strokeOpacity="0.18" strokeWidth="14" fill="none" strokeLinecap="round" />
        {/* value arc */}
        <path
          d={arcPath(startAngle, valueAngle)}
          stroke={color.hex}
          strokeWidth="14"
          fill="none"
          strokeLinecap="round"
          style={{ transition: "stroke 0.3s" }}
        />
        {/* marker dot */}
        {(() => {
          const p = polar(valueAngle);
          return <circle cx={p.x} cy={p.y} r="8" fill="#fff" stroke={color.hex} strokeWidth="3" />;
        })()}
      </svg>
      <div className="absolute inset-x-0 bottom-0 flex flex-col items-center">
        <span className="font-display text-5xl font-semibold tabular-nums" style={{ color: color.hex }} data-testid="risk-result-score">
          {score}
        </span>
        <span className="text-xs text-muted-foreground">out of 100</span>
      </div>
    </div>
  );
};
